module.exports = __webpack_public_path__ + "img/radio-asyik.1aa893cd.jpg";